import * as Yup from 'yup';

import i18n from '../../../i18n';

export const feedbackValidationSchema = () =>
    Yup.object().shape({
        message: Yup.string().required(i18n.t('error.feedback-empty', { ns: 'errors' })),
    });
